import React, { useEffect, useState } from 'react';
import RedirectButton from '../components/RedirectButton/RedirectButton';

const Home = () => {
  useEffect(() => {
    const redirectTimeout = setTimeout(() => {
      window.location.replace('https://divisionsmg.com/dmg-pro/');
    }, 4000); // 4000 milliseconds = 4 seconds

    return () => {
      clearTimeout(redirectTimeout);
    };
  }, []);

  const reDirect = () => {
    window.location.href = 'https://divisionsmg.com/dmg-pro/';
  };

  const [descriptionWidth, setDescriptionWidth] = useState('48%');

  useEffect(() => {
    const handleResize = () => {
      const screenWidth = window.innerWidth;
      if (screenWidth <= 768) {
        setDescriptionWidth('100%');
      } else {
        setDescriptionWidth('48%');
      }
    };

    window.addEventListener('resize', handleResize);

    return () => {
      window.removeEventListener('resize', handleResize);
    };
  }, []);
  
  return (
    <div style={styles.container}>
      <h1 style={styles.heading}>Our website has moved!</h1>
      <p style={{ ...styles.description, width: descriptionWidth }}>
        To serve you better with new exciting features and informative content we have shifted our website to &nbsp;
        <a href="https://divisionsmg.com/dmg-pro/">https://divisionsmg.com/dmg-pro/</a>
      </p>
      <p style={styles.redirectMessage}>
        You will be redirected to our website shortly.
      </p>
      <RedirectButton reDirect={reDirect} />
    </div>
  );
};

const styles = {
  container: {
    textAlign: 'center',
    padding: '40px',
    margin: "10% 0"
  },
  heading: {
    fontSize: '24px',
    fontWeight: 'bold',
    marginBottom: '20px',
  },
  description: {
    fontSize: '18px',
    marginBottom: '20px',
    marginRight: 'auto',
    marginLeft: 'auto',
  },
  redirectMessage: {
    fontSize: '16px',
    fontStyle: 'italic',
  },
};

export default Home;
